import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, Typography, Space, Spin, Row, Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Logo from './Logo';
import { useTracking } from '../hooks/useTracking';

const { Title, Text } = Typography;

const MicrosoftLoginSuccess = ({ onLogin }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { trackLogin } = useTracking();

  useEffect(() => {
    const processLogin = async () => {
      const token = searchParams.get('token');
      const username = searchParams.get('username');
      const email = searchParams.get('email');
      const role = searchParams.get('role'); // Capturar role da URL
      const error = searchParams.get('error');
      
      // Capturar o token Azure da URL
      const azureToken = searchParams.get('azure_token');
      const azureExpires = searchParams.get('azure_expires');
      
      if (error) {
        console.error('Erro na autenticação Microsoft:', error);
        navigate('/microsoft-login-error', { replace: true });
        return;
      }
      
      if (token && username && email) {
      // Salvar token de autenticação no localStorage
      localStorage.setItem('token', token);
      
      // Salvar token Azure no localStorage
      if (azureToken) {
        localStorage.setItem('azureToken', azureToken);
        console.log('Token Azure capturado e salvo');
      }
      
      if (azureExpires) {
        localStorage.setItem('azureTokenExpires', azureExpires);
        console.log('Expiração do token Azure salva');
      }
      
      // Salvar dados do usuário com o role correto do backend
      const userData = {
        username: username,
        email: email,
        role: role || 'user' // Usar role do backend, ou 'user' como fallback
      };
      
      localStorage.setItem('userData', JSON.stringify(userData));
      
      // Registrar login no sistema de analytics
      await trackLogin();
      
      // Fazer login
      onLogin(token, userData);
      
      // Redirecionar para o painel
      navigate('/painel', { replace: true });
      } else {
        console.error('Parâmetros de autenticação ausentes');
        navigate('/microsoft-login-error', { replace: true });
      }
    };
    
    processLogin();
  }, [searchParams, onLogin, navigate, trackLogin]);

  return (
    <Row 
      justify="center" 
      align="middle" 
      style={{ 
        minHeight: '100vh', 
        padding: '24px'
      }}
    >
      <Col xs={22} sm={20} md={16} lg={12} xl={8}>
        <Card
          bordered={false}
          style={{
            borderRadius: 16,
            boxShadow: '0 8px 32px rgba(45, 95, 63, 0.10)',
            border: '2px solid #ae9560'
          }}
          bodyStyle={{ padding: '48px 40px' }}
        >
          <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Logo size="xlarge" />
              <Title level={4} style={{ margin: 0, color: '#6c757d', fontWeight: 400 }}>
                Processando autenticação...
              </Title>
            </Space>

            <Space direction="vertical" size="middle" style={{ width: '100%', padding: '40px 0' }}>
              <Spin 
                indicator={<LoadingOutlined style={{ fontSize: 48, color: '#024638' }} spin />} 
                size="large"
              />
              <Text style={{ fontSize: 16, color: '#4a7c59', fontWeight: 500 }}>
                Aguarde, estamos finalizando seu login...
              </Text>
            </Space>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default MicrosoftLoginSuccess; 